import React from 'react';

const FilterBar = ({ filter, setFilter, search, setSearch }) => (
  <div className="header" style={{ justifyContent: 'space-between', gap: 16 }}>
    <div style={{ display: 'flex', gap: 8 }}>
      <button
        className={`add-button ${filter === 'active' ? 'active' : ''}`}
        onClick={() => setFilter('active')}
      >Aktywne</button>
      <button
        className={`add-button ${filter === 'archived' ? 'active' : ''}`}
        onClick={() => setFilter('archived')}
      >Zarchiwizowane</button>
      <button
        className={`add-button ${filter === 'all' ? 'active' : ''}`}
        onClick={() => setFilter('all')}
      >Wszystkie</button>
    </div>
    <input
      type="text"
      placeholder="Szukaj…"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      style={{ padding: '8px 12px', minWidth: 220 }}
    />
  </div>
);

export default FilterBar;
